import {VscContent} from "./ContentComponent";
import * as React from "react";
import {useSlsOrds} from "../../data/slsOrdSource";
import SiteSpecific from "../screens/vscSiteSpecific/SiteSpecific";
import {useCommunityData} from "./CommunityDataLoader";


export const VscMarketHome: React.FC<{}> = (props) => {


    const communityData = useCommunityData();

    const slsOrds = communityData?.homes;

    if (!slsOrds) return <div>Loading</div>
    return <SiteSpecific
            slsOrds={slsOrds}
             favorites={new Set()} updateFavorites={() => 0} />;



}